import styled, { css } from "styled-components";

export const Tab = styled.div`
  ${({ theme }) => css`
    height: 42px;
    background: #FFFFFF;
    font-size: 14px;
    line-height: 17px;
    color: #566F75;
    padding: 0px 13px;
    white-space: nowrap;

    display: flex;
    align-items: center;

    cursor: pointer;

    border: 1px solid #E3E3E3;
    
    ${p => p.left && css`
      border-radius: 8px 0px 0px 8px;
    `}

    ${p => p.middle && css`
      border-left: 0px;
    `}

    ${p => p.right && css`
      border-radius: 0px 8px 8px 0px;
      border-left: 0px;
    `}

    svg {
        fill: #566F75;
      }

    ${p => p.selected && css`
      color: ${theme?.colour?.primary};
      background: ${`${theme?.colour?.primary}0D`};

      svg {
        fill: ${theme?.colour?.primary};
      }
    `}

    &:hover {
      color: ${theme?.colour?.primary};
      background: ${`${theme?.colour?.primary}0D`};

      svg {
        fill: ${theme?.colour?.primary};
      }
    }
  `}
`;